App.CookingLine = DS.Model.extend
  name          : DS.attr 'string'
  organization  : DS.belongsTo 'organization', async: true

  dishes        : DS.hasMany   'draft_dishes',   async: true, inverse: 'cooking_line'
